"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHref = exports.getDocumentUrlByCollectionName = exports.getThematicPlanLink = exports.completePreviewLink = exports.getStatisticLink = exports.getSheetLink = exports.getNodeLink = exports.getLawLink = exports.getGlossaryTermLink = exports.getAnalysisLink = exports.getDecisionLink = exports.getBookLink = exports.getBooksLink = exports.getArticleLink = void 0;
var models_1 = require("@livv/models");
var getArticleLink = function (id) { return "/articles/".concat(encodeURIComponent(id)); };
exports.getArticleLink = getArticleLink;
var getBooksLink = function () { return '/books'; };
exports.getBooksLink = getBooksLink;
var getBookLink = function (_a) {
    var bookId = _a.bookId;
    return "".concat((0, exports.getBooksLink)(), "/").concat(encodeURIComponent(bookId));
};
exports.getBookLink = getBookLink;
var getDecisionLink = function (decisionId, analysisId) {
    return "/decisions/".concat(encodeURIComponent(decisionId)).concat(analysisId ? "?analysisId=".concat(encodeURIComponent(analysisId)) : '');
};
exports.getDecisionLink = getDecisionLink;
var getAnalysisLink = function (analysisId, decisionId) {
    return (0, exports.getDecisionLink)(decisionId, analysisId);
};
exports.getAnalysisLink = getAnalysisLink;
var getGlossaryTermLink = function (glossaryTermId) {
    return "/glossary/".concat(encodeURIComponent(glossaryTermId));
};
exports.getGlossaryTermLink = getGlossaryTermLink;
var getLawLink = function (lawId) { return "/laws/".concat(encodeURIComponent(lawId)); };
exports.getLawLink = getLawLink;
var getNodeLink = function (_a) {
    var bookId = _a.bookId, bookPath = _a.bookPath;
    return "".concat((0, exports.getBookLink)({ bookId: bookId }), "/").concat(encodeURIComponent(bookPath));
};
exports.getNodeLink = getNodeLink;
var getSheetLink = function (_a) {
    var sheetId = _a.sheetId, bookId = _a.bookId, bookPath = _a.bookPath;
    return "".concat((0, exports.getNodeLink)({ bookId: bookId, bookPath: bookPath }), "/").concat(encodeURIComponent(sheetId));
};
exports.getSheetLink = getSheetLink;
var getStatisticLink = function (id) { return "/statistics/".concat(encodeURIComponent(id)); };
exports.getStatisticLink = getStatisticLink;
var completePreviewLink = function (baseHref, appUrl, query) {
    var url = new URL("https://".concat(appUrl).concat(baseHref));
    if (query) {
        url.searchParams.append('search', query);
    }
    return "".concat(url.pathname).concat(url.search);
};
exports.completePreviewLink = completePreviewLink;
var getThematicPlanLink = function (theme, indexName, keyword, modelType, scrollToResults) {
    if (scrollToResults === void 0) { scrollToResults = false; }
    return keyword
        ? "/search/icicle/".concat(__spreadArray([theme, keyword.treeId], __read(keyword.path), false).join('%2F')).concat(modelType
            ? "?".concat(indexName, "[menu][modelType]=").concat(modelType).concat(scrollToResults ? '#results' : '')
            : '')
        : '/search/icicle';
};
exports.getThematicPlanLink = getThematicPlanLink;
/**
 * Wrapper util for building urls
 * @param collectionName collection in which the document is stored
 * @returns getDocumentUrl : a function taking the documentId and eventually its data (CodeArticles, PublicationSheets) to build its url
 */
var getDocumentUrlByCollectionName = function (collectionName) {
    switch (collectionName) {
        case models_1.CollectionName.ANALYSES:
            return function (analysisId, _a) {
                var decisionId = _a.decisionId;
                return (0, exports.getAnalysisLink)(analysisId, decisionId);
            };
        case models_1.CollectionName.ARTICLES:
            return exports.getArticleLink;
        case models_1.CollectionName.DECISIONS:
            return function (decisionId) { return (0, exports.getDecisionLink)(decisionId); };
        case models_1.CollectionName.CODE_ARTICLES:
        case models_1.CollectionName.PUBLICATION_SHEETS:
            return function (docId, _a) {
                var keyword = _a.keyword;
                return (0, exports.getSheetLink)({
                    bookId: keyword.treeId,
                    bookPath: keyword.path.join('/'),
                    sheetId: docId,
                });
            };
        case models_1.CollectionName.GLOSSARY_TERMS:
            return exports.getGlossaryTermLink;
        case models_1.CollectionName.LAW_TEXTS:
            return exports.getLawLink;
        case models_1.CollectionName.STATISTICS:
            return exports.getStatisticLink;
        default:
            return undefined;
    }
};
exports.getDocumentUrlByCollectionName = getDocumentUrlByCollectionName;
var getHref = function (_a) {
    var baseObjectID = _a.baseObjectID, hit = __rest(_a, ["baseObjectID"]);
    switch (hit.modelType) {
        case models_1.ModelType.ANALYSIS: {
            var decisionId = hit.decisionId;
            return (0, exports.getDecisionLink)(decisionId, baseObjectID);
        }
        case models_1.ModelType.ARTICLE:
            return (0, exports.getArticleLink)(baseObjectID);
        case models_1.ModelType.DECISION:
            return (0, exports.getDecisionLink)(baseObjectID);
        case models_1.ModelType.GLOSSARY_TERM: {
            var redirectionId = hit.redirectionId;
            return (0, exports.getGlossaryTermLink)(redirectionId || baseObjectID);
        }
        case models_1.ModelType.LAW_TEXT: {
            var path = hit.path, treeId = hit.treeId;
            var isCodeArticle = baseObjectID.startsWith(models_1.LawType.LEGIARTI);
            return isCodeArticle
                ? (0, exports.getSheetLink)({ bookId: treeId, bookPath: path.join('/'), sheetId: baseObjectID })
                : (0, exports.getLawLink)(baseObjectID);
        }
        case models_1.ModelType.PUBLICATION_SHEET: {
            var path = hit.path, treeId = hit.treeId;
            return (0, exports.getSheetLink)({
                bookId: treeId,
                bookPath: path.join('/'),
                sheetId: baseObjectID,
            });
        }
        case models_1.ModelType.STATISTIC:
            return (0, exports.getStatisticLink)(baseObjectID);
        default:
            return '';
    }
};
exports.getHref = getHref;
//# sourceMappingURL=links.js.map